import type { EnvConfig } from '@config/env/env-config-provider.types';

export type ResolvedAnalyticsConfig = {
    posthogEnabled: boolean
    posthogTrackingGroups: string | undefined
    teacherTotterEnabled: boolean
    teacherTotterSyncUrl: string
    identityGatewayUrl: string
};

const parseBoolean = (value: string | boolean | undefined): boolean => (
    value === true || value === 'true'
);

export const resolveAnalyticsConfig = (envConfig: EnvConfig): ResolvedAnalyticsConfig => ({
    posthogEnabled: parseBoolean(envConfig.POSTHOG_ENABLED),
    posthogTrackingGroups: envConfig.POSTHOG_TRACKING_GROUPS,
    teacherTotterEnabled: parseBoolean(envConfig.TEACHER_TOTTER_ENABLED),
    teacherTotterSyncUrl: envConfig.TEACHER_TOTTER_SYNC_URL,
    identityGatewayUrl: envConfig.IDENTITY_GATEWAY_URL
});
